module.exports = __webpack_public_path__ + "static/media/gameBoy.79ddd4cf.png";